import React from "react";
import { Box, TextField } from "@mui/material";
import SearchIcon from "assets/icons/search_icon.svg";
import strings from "global/constants/StringConstants";
import { debounceEventHandler } from "helpers/methods";
import {
  reportSearchAdornmentSx,
  reportSearchFieldResponsiveSx,
  reportSearchInputProps,
  reportSearchWrapperSx,
} from "screens/Reports/helpers/reportsToolbarStyles";

interface ReportsSearchFieldProps {
  /** Doubles as the field's accessible name — a placeholder is not a label. */
  placeholder: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * The search field every Reports tab opens with.
 *
 * It was the same twenty lines inlined in all four views; it is one component
 * here so the phone/tablet chrome from `Reports - Mobile & Tablet.dc.html` (a
 * 40px pill instead of the desktop's 56px frame) is written once. The desktop
 * markup and styling are unchanged.
 */
const ReportsSearchField = ({
  placeholder,
  onSearchChange,
}: ReportsSearchFieldProps) => (
  <Box sx={reportSearchWrapperSx}>
    <TextField
      placeholder={placeholder}
      variant="outlined"
      fullWidth
      onChange={debounceEventHandler(onSearchChange, strings.SEARCH_TIME_OUT)}
      sx={reportSearchFieldResponsiveSx}
      inputProps={reportSearchInputProps(placeholder)}
      InputProps={{
        startAdornment: (
          <Box sx={reportSearchAdornmentSx}>
            <img
              src={SearchIcon}
              width="20"
              height="20"
              alt=""
              aria-hidden="true"
            />
          </Box>
        ),
      }}
    />
  </Box>
);

export default ReportsSearchField;
